import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useUser } from "stores/useUser";

// Role-based route guard. Use after RequireAuth.
// Usage: <Route element={<RequireRole allowedRoles={["admin"]} />}> ... </Route>
export default function RequireRole({ allowedRoles = [] }) {
  const location = useLocation();
  const { user } = useUser();

  const rolesFromUser = Array.isArray(user?.roles)
    ? user.roles
    : user?.role
    ? [user.role]
    : [];

  const isAuthorized = allowedRoles.length === 0
    ? true
    : rolesFromUser.some((r) => allowedRoles.includes(String(r)));

  if (!isAuthorized) {
    return (
      <Navigate
        to="/workspace"
        replace
        state={{ from: location, reason: "forbidden" }}
      />
    );
  }

  return <Outlet />;
}


